<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">


    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >API Audits
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          API Audits capture all system requests and responses for easy tracking
          and visibility.
        </div>
      </div>

      <div class="spacer2"></div>

     

<mat-form-field style="display: none">
          <mat-label>Select a user</mat-label>
          <mat-select (selectionChange)="onUserChange($event)">
            <mat-option [value]="">Select all</mat-option>
            @for (user of users?.data?.profiles; track user.userkey) {
            <mat-option [value]="user.userkey">{{ user.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Filter Trigger Button -->
        <button
          mat-stroked-button
          [matMenuTriggerFor]="filterMenu"
          style="border-color: #65696d7a"
          class="filter-trigger"
        >
          <mat-icon>filter_list</mat-icon> Filters
        </button>

        <!-- Filter Popup Menu mdc-text-field-->
        <mat-menu
          #filterMenu="matMenu"
          class="filter-menu-panel"
          [overlapTrigger]="false"
        >
          <div class="filter-card" (click)="$event.stopPropagation()">
            <div class="form-field button-container" id="ft">
              <mat-label class="wid-80px">Created Date</mat-label>
              <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="form-input filter-field datepicker-field"
                style="width: 100%"
              >
                <input
                  matInput 
                  class="filter-input"
                  [matDatepicker]="picker"
                  [min]="minDate"
                  [max]="maxDate"
                  [formControl]="createdDateControl"
                  placeholder="Pick a date"
                  (focus)="picker.open()"
                  (keydown)="$event.preventDefault()"
                  readonly
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-field button-container" >
              <mat-label class="wid-80px">Users</mat-label>
              <mat-form-field appearance="fill" class="filter-field w-100" style="width: 100%;">
                <mat-select
                  (selectionChange)="onUserChange($event)"
                  [value]="userKey && userKey != null ? userKey : 'All Users'"
                >
                  <mat-option [value]="''">All Users</mat-option>
                  @for (user of users?.data?.profiles; track user.userkey) {
                  <mat-option [value]="user.userkey">{{
                    user.name
                  }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- <div class="filter-actions">
      <button mat-stroked-button (click)="resetFilter()">Reset</button>
      <button mat-flat-button color="primary" (click)="applyFilter()">Apply</button>
    </div> -->
            <div
              class="button-container"
              style="text-align: right; justify-content: flex-end"
            >
              <button
                mat-raised-button
                color="accent"
                (click)="resetFilter()"
                class="ml5"
              >
                {{ "Reset" }}
              </button>
              <button
                mat-raised-button
                color="primary"
                class="clr-white"
                (click)="applyFilter()"
              >
                {{ "Apply" }}
              </button>
            </div>
          </div>
        </mat-menu>
        
      <div class="spacer2"></div>
      <div class="clear"></div>

       <div class="example-container">
      <div class="leftnavfull cal" [ngClass]="{ 'leftnav': previewFile }">
        <table
          mat-table
          [dataSource]="audits?.data?.audits"         
        >
          <ng-container matColumnDef="processId">
            <th mat-header-cell *matHeaderCellDef>Process ID</th>
            <td mat-cell *matCellDef="let element">{{ element?.processId }}</td>
          </ng-container>

          <ng-container matColumnDef="url">
            <th mat-header-cell *matHeaderCellDef>URL</th>
            <td mat-cell *matCellDef="let element">
              /{{ element?.url.split("/").pop() || "" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Occurred At</th>
            <td mat-cell *matCellDef="let element">
              {{
                element?.createdAt
                  | tzfmt : "yyyy-MM-dd HH:mm:ss" : appService.TimeZoneName
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="elapsedTime">
            <th mat-header-cell *matHeaderCellDef>Duration</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.elapsedTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Details</th>
            <td mat-cell *matCellDef="let element">
              <a (click)="showPreview(element?.id)" matTooltip="View" *ngIf="selectedProcessId !== element?.processId" class="pointer routeClr"
                ><i class="fa-solid fa-eye"></i
              ></a>
              <i class="fa-solid fa-eye" *ngIf="selectedProcessId === element?.processId"></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns" (click)="selectRow(row)"
            [ngClass]="{ 'highlighted': selectedProcessId === row.processId }"
            >
          </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh;">
            {{ loading ? 'Loading...' : 'No data found' }}
          </td>
        </tr> 
        </table>
      </div>

      <div class="rightnav" *ngIf="previewFile">
        <i class="fa-regular fa-circle-xmark pointer routeClr" style="float: right;" (click)="closeRtNav()" matTooltip="Close"></i>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="Request">
            <pre>{{ parsedRequestBody | json }}</pre>
          </mat-tab>
          <mat-tab label="Response">
            <pre>{{ parsedResponseBody | json }}</pre>
          </mat-tab>
        </mat-tab-group>
      </div>

      </div>

    </div>


    </div>
  </div>
</div>
